
<template>
  <div class="detail">
    <h3>{{ detail.title }}</h3>

    <div class="content">
      <p>5分钟延时周期</p>
      <p>(1)定义：</p>
      <p>
        竞价结束前五分钟内出价，竞价结束时间会在出价时间的基础上延长五分钟，五分钟内的每次出价都会触发延时（具体以标的物详情页的倒计时为准）
      </p>
      <img style="width: 100%" src="@/assets/img/timeLapseImg1.png" alt="" />
      <p>(2)理解误区</p>
      <p>
        很多客户把延时周期理解为五分钟无其他人出价的话，竞价即结束。这样的理解是错误的哦，竞价有固定的竞价周期，不会在长时间无人出价的情况下提前结束。
      </p>
      <img style="width: 50%" src="@/assets/img/timeLapseImg2.png" alt="" />
    </div>
  </div>
</template>

<script>
import request from '@/util/request'
export default {
  data () {
    return {
      detail: {
        title: '竞价延时说明',
        source: '竞价延时详情',
        logintime: '2023-08-10 10:00:00',
        content: '竞价延时详情'
      }
    }
  },
  created () {
    // console.log(this.$route.query.id);
    // let id = this.$route.query.id;
    // let url = 'content';
    // console.log(this.ajax_id(url,id).data);
    // this.detail = this.ajax_id(url, id).data

  },
  mounted () { },
  computed: {},
  watch: {},
  methods: {

  },
};
</script>
<style>
.content > p > span {
  font-size: 28px !important;
  font-family: 楷体, 楷体_GB2312 !important;
}
.content > p > a {
  text-decoration: underline !important;
}
</style>
<style scoped>
.detail {
  padding: 41px 260px 60px 260px;
  margin: 0 auto;
  margin-bottom: 30px;
  width: 1300px;
  height: auto;
  min-height: 500px;
  background: #ffffff;
  box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
}

.detail h3 {
  max-width: 1200px;
  margin: 0 auto;
  height: 52px;
  font-size: 34px;
  font-family: Microsoft YaHei;
  font-weight: 500;
  line-height: 52px;
  text-align: center;
  color: #333333;
  letter-spacing: 3px;
  /* white-space: nowrap; */
  /* overflow: hidden; */
  /* text-overflow: ellipsis; */
}

.detail h4 {
  margin: 0 auto;
  padding: 33px 0;
  width: 750px;
  font-size: 28px;
  height: auto;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  margin-top: 50px;
}

.detail h4 span {
  display: block;
  width: auto;
  height: 16px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 16px;
  color: #999999;
}

.detail .content {
  text-indent: 2em;
  width: 1300px;
  height: auto;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 40px;
  color: #666666;
  overflow: hidden;
  margin-top: 20px;
}
</style>